(function(){
    const addToMoodboard = document.querySelector('.btn-moonboard');
    const metzProdID = document.querySelector('.metz_product_id');
    const metzProdSlug =  document.querySelector('.metz_product_slug');
    const metzProdTitle = document.querySelector('.product-title');
    const metzAction = document.querySelector('.metz_action');
    const metzMoodboard = document.querySelector('.metz-moodboard');

    if(addToMoodboard){
        addToMoodboard.addEventListener('click',function(e){
            let metzProdIDVal = metzProdID != '' ? metzProdID.value : '';
            let metzProdSlugVal = metzProdSlug != '' ? metzProdSlug.value : '';
            let metzProdTitleVal = metzProdTitle != '' ? metzProdTitle.value : '';
            let metzProdActionVal = metzAction != '' ? metzAction.value : '';
            metz_add_to_moodboard(metzProdIDVal,metzProdSlugVal,metzProdTitleVal,metzProdActionVal);
        })
    }

    function removeMoodBoardItem(){
        if(metzMoodboard){
            const metzMoodboardRem = document.querySelectorAll('.moodboard-item-remove');
            if(metzMoodboardRem){
                metzMoodboardRem.forEach((item)=>{
                    item.addEventListener('click',function(e){
                        let clickedAction = this.getAttribute('action');
                        let clickedProdID = this.getAttribute('prodID');
                        let clickedProdName = this.getAttribute('prodName');
                        let parentElement = this.closest('.col-6.col-md-3');
                        
                        parentElement.remove();
                        metz_add_to_moodboard(clickedProdID,clickedProdName,clickedProdName,clickedAction);
                    })
                })
            }
        }
    }
    
    removeMoodBoardItem();

    function metz_add_to_moodboard(productID = '',productSlug = '',productTitle = '', productAction = ''){
        let prodData = '';
        const moodBoardCount = document.querySelector('.moodboard-count');//for moodboard count 
        const moodBoardHeadingTitle = document.querySelector('.metz-moodboard--heading h2');
        if(productAction == 'remove'){
            if(metzMoodboard){
                metzMoodboard.innerHTML += '<div id="loading" class="show"><div class="loader"></div></div>';
            }
        }
        prodData +="&productID=" + productID;
        prodData +="&productSlug=" + productSlug;
        prodData +="&productTitle=" + productTitle;
        prodData +="&productAction=" + productAction;

        // Ajax request
        let request = new XMLHttpRequest();
        request.open("POST", metz_ajax_callback_data.ajax_url, true);
        request.setRequestHeader(
        "Content-Type",
        "application/x-www-form-urlencoded; charset=UTF-8"
        );
        request.onreadystatechange = () => {
            if (request.readyState === 4) {
                if(productAction == 'remove'){
                    const loadMoreGif = document.querySelector("#loading");
                    if(loadMoreGif){
                        loadMoreGif.remove();
                    }
                    const pdfButton = document.querySelector('.download-pdf-button');
                    const responseData = JSON.parse(request.response);
                    let prodCount = responseData.data.count;
                    if(prodCount == 0){
                        if(pdfButton){
                            pdfButton.remove();
                            metzMoodboard.innerHTML +='<div class="text-center"><h4>No Products added in the moodboard</h4></div>';
                        }
                    }
                    if(moodBoardCount){
                        //Dynamically change the moodboard item count in the heart icon in navigation bar
                        moodBoardCount.innerHTML = prodCount;
                    }
                    if(moodBoardHeadingTitle){
                        document.getElementById("moodboard-selection-count").textContent = "Your Moodboard Selections ("+ prodCount +")";
                    }
                    removeMoodBoardItem();
                }
                if(productAction == 'add' && addToMoodboard){
                    const responseData = JSON.parse(request.response);
                    let prodCount = responseData.data.count;
                    //Change the text Add to moodboard to added
                    addToMoodboard.innerHTML = '<span class="fontawsemoneLight">Heart</span>ADDED TO MOODBOARD';
                    if(moodBoardCount){
                        //Dynamically change the moodboard item count in the heart icon in navigation bar
                        moodBoardCount.innerHTML = prodCount;
                    }
                }
                // if(moodBoardCount){
                //     //Dynamically change the moodboard item count in the heart icon in navigation bar
                //     moodBoardCount.innerHTML = prodCount;
                // }
                
            }
        };
        request.send(
        "action=add_to_moodboard&nonce=" +
            metz_ajax_callback_data.ajax_nonce +
            prodData
        );
    }
})();